import { AveliosButton } from '@components/common-layout/avelios-button';
import { QuestionsAndAnswer } from '@components/question-and-answer/types';
import { Col, Row } from 'antd';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { TENANT_NAME } from '../../../tenant/tenant-names';
import { QuestionAndAnswerCollapse } from '../../question-and-answer/question-and-answer-collapse';
import styles from './question-and-answer.module.scss';

export const QuestionAndAnswer: FC = () => {
  const { formatMessage } = useIntl();

  const router = useRouter();

  const generalQuestionsAndAnswers: QuestionsAndAnswer[] = [
    {
      key: 'data-security',
      question: formatMessage({ id: 'home.qa.1.question' }),
      answer: formatMessage({ id: 'home.qa.1.answer' }),
    },
    {
      key: 'rescheduling',
      question: formatMessage({ id: 'home.qa.2.question' }),
      answer: formatMessage({ id: 'home.qa.2.answer' }),
    },
    {
      key: 'pricing',
      question: formatMessage({ id: 'home.qa.3.question' }, { tenant: TENANT_NAME }),
      answer: formatMessage({ id: 'home.qa.3.answer' }, { tenant: TENANT_NAME }),
    },
    {
      key: 'appointment-confirmation',
      question: formatMessage({ id: 'home.qa.4.question' }),
      answer: formatMessage({ id: 'home.qa.4.answer' }),
      additionalContent: formatMessage({ id: 'home.qa.4.content' }),
    },
    {
      key: 'no-appointment-confirmation',
      question: formatMessage({ id: 'home.qa.5.question' }),
      answer: formatMessage({ id: 'home.qa.5.answer' }),
      additionalContent: (
        <div>
          <AveliosButton type={'primary'} onClick={() => router.push('/appointments')}>
            {formatMessage({ id: 'home.qa.5.content' })}
          </AveliosButton>
        </div>
      ),
    },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <Row gutter={32}>
          <Col lg={12} xs={24}>
            <div>
              <span style={{ fontSize: '2.5em', fontWeight: 300 }}>
                {formatMessage({ id: 'home-qa.title' })}
              </span>
            </div>
            <div>
              <span style={{ fontWeight: 200, fontSize: '1.3em' }}>
                {formatMessage({ id: 'home-qa.subtitle' })}
              </span>
            </div>
          </Col>
          <Col lg={12} xs={24}>
            <QuestionAndAnswerCollapse questionsAndAnswers={generalQuestionsAndAnswers} />
          </Col>
        </Row>
      </div>
    </div>
  );
};
